import React from "react";
import resume from "../assets/files/Daniel Agbeleshe.pdf";

import image2 from "../assets/avatar.png";

// intersection observer hook
import { useInView } from "react-intersection-observer";
import { Link } from "react-scroll";
import StatsSection from "./reusables/StatsSections";

const About = () => {
  const [ref, inView] = useInView({
    threshold: 0.5,
  });

  return (
    <section
      id="about"
      className="md:mb-[300px] mt-[100px]  md:mt-[200px] section"
      ref={ref}
    >
      <div className="container mx-auto">
        <div className="flex relative flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen">
          {/* image */}
          <div className="flex-1">
            {/* Desktop */}
            <img
              src={image2}
              alt="image of Daniel"
              className="hidden md:flex h-[300px] lg:h-[650px] mb-[700px] lg:mb-0  rounded-full mx-auto"
            />

            {/* Mobile */}
            <img
              src={image2}
              alt="image of Daniel"
              className="md:hidden absolute opacity-50 right-[-30%] top-[-10%] flex-col  h-[300px]  mb-[700px] lg:mb-0  rounded-full mx-auto"
            />
          </div>

          {/* text */}
          <div className="flex-1 mt-[-700px] lg:mt-0 z-10">
            <h2 className="h2 text-accent font-extrabold text-center">
              About me.
            </h2>
            <h3 className="h3 mb-4 text-center">
              4+ Years of Professional Experience
            </h3>

            <p className="text-justify">
              I specialize in building intuitive, user-friendly interfaces that
              are fully responsive and accessible across a wide range of devices
              and platforms. My expertise includes leveraging modern frameworks
              and libraries such as React and Tailwind CSS to deliver scalable,
              efficient, and maintainable applications.
            </p>

            {/* Counter */}
            <StatsSection />
            <div className="items-center flex max-w-max gap-x-6 mx-auto">
              <Link smooth={true} to="contact">
                <button className="btn btn-lg mr-5">Contact Me</button>
              </Link>
              <a
                href={resume}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gradient btn-link"
              >
                My resume
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
